import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ZuoraUserInfoResponse } from '../models/zuora-user-info-response.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ZuoraService {
  accountNumber = '';
  constructor(private http: HttpClient) {}

  private zuoraEmailRequestUrl = `${environment.zuoraApiUrl}/account/contactemailverify/`;

  getUserAccountNumberByEmail(
    token: string,
    email: string
  ): Observable<ZuoraUserInfoResponse> {
    let url = `${this.zuoraEmailRequestUrl}${email}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<ZuoraUserInfoResponse>(url, {
      headers: headers,
    });
  }

  setAccountNumberOnService(accountNumber: string) {
    this.accountNumber = accountNumber;
  }

  getAccountNumberOnService() {
    return this.accountNumber;
  }
}
